<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex lg12 sm12 xs12>
        <v-card class="app-card">
          <v-card-title class="app-card-title mb-0">
            <h4 class="text">Renovação de Veículo</h4>
            <v-spacer></v-spacer>            
            <v-btn
              v-if="order"
              color="warning"
              outlined
              depressed
              type="button"
              small
              @click="$router.push({ name: `orders-detail`, params: { id: order.id } })"
            >
             Pedido: {{ order.id }}
            </v-btn>
          </v-card-title>
          <v-card-text class="app-card-content" style="padding: 0px;">            
            <OrderCheckout :orderKind="orderKind"/>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>            
            <v-btn outlined color="error">Voltar</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import OrderCheckout from './components/OrderCheckout.vue';
import OrderService from '@/services/order.service';

export default {
  name: "VehicleRenewal",
  
  components: {
    OrderCheckout
  },
  data: () => ({
    orderKind: 'RENOVACAO_REGISTRO_VEICULO',
    order: null,
  }),
  mounted() {
    this.fetchOrder();
  },
  watch: {
    '$route.params.id'(newId, oldId) {      
      this.fetchOrder()
    }
  },
  methods: {
    fetchOrder() {
      if (!this.$route.params.id) return;

      OrderService
        .show(this.$route.params.id)
        .subscribe({
          next: (response) => {            
            this.order = response;            
          }
      });
    }
  }
};
</script>